const handleDeleteUserFormParamUser = {
  confirm: '¿Realmente desea eliminar este colaborador?',
  title: 'ELIMINAR COLABORADOR'
};

export default handleDeleteUserFormParamUser;
